import React from 'react'
import LayoutHome from '../../components/layout/LayoutHome';

const Egresos = () => {
  return (
    <LayoutHome pageSeleccionada="egresos">
      <div>Egresos</div>
    </LayoutHome>
  )
}

export default Egresos;